<template>
    <error404/>
</template>

<script>
    import Error404 from "_private/components/super/errorPage/404";

    export default {
        components: {
            Error404
        }
    };
</script>
